import WrapperInputGroup from "./WrapperInputGroup";
import {MaskInput} from "./MaskInput";
import PropTypes from "prop-types";

export const MaskInputGroup = WrapperInputGroup(MaskInput);

MaskInputGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        placeholder: PropTypes.string,
    }).isRequired,
    mask: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/input/base/MaskInputGroup.js